import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./styless.scss";
class MyLinksTable extends React.Component {
  static propTypes = {
    getLinks: PropTypes.func,
    myLinks: PropTypes.array
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  
  render() {
    const { myLinks } = this.props;
    return (
      <React.Fragment>
        <div className="columns">
          <div className="column">
            <div className="card">
              <div className="card-content">
                <div className="columns is-gapless">
                  <div className="column is-9">
                    <p className="title is-4">My Links</p>
                  </div>
                  <div className="column is-3">
                    <Link to="/user/generatelink">Magic Link Generator</Link>
                  </div>
                </div>

                <table className="table  is-striped is-narrow is-hoverable is-scrollable header_fixed">
                  <thead className="tablehd">
                    <tr>
                      <th width="15%">
                        <abbr title="Position">Action</abbr>
                      </th>
                      <th width="60%">
                        <abbr title="Played">Validation Url</abbr>
                      </th>
                      <th width="15%">
                        <abbr title="Won">Destinatory Email</abbr>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {myLinks.map(function(element, index) {
                      return (
                        <tr key={index}>
                          <td width="15%"> {element.actionName}</td>
                          <td width="70%">
                            <a href={element.link}>{element.link}</a>{" "}
                          </td>
                          <td width="15%"> {element.address}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MyLinksTable;
